// extracted by mini-css-extract-plugin
module.exports = {"recipe":"recipe_recipe__iQSBG","image":"recipe_image__3Yow_"};